// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1UlZ2","inputWrap":"Table_inputWrap__NJ4__","col":"Table_col__2udOe","bmiTooltip":"Table_bmiTooltip__2U5Br"};